const DATE_LOCALE = "en-GB"

const DATE_OPTIONS = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
}

export const formatDate = (dateTimeAsString, locale = DATE_LOCALE, options = DATE_OPTIONS) => {
    const dateTime = new Date(dateTimeAsString);
    return dateTime.toLocaleDateString(locale, options)
}
